import React, { useState, useEffect } from 'react';
import { BodySBold } from 'components/Typography/Typography';
import { ECommerceService } from 'services/eCommerce/eCommerce';
import { translate } from 'components/Translation';
import { roundMoney } from 'utils/converters/roundMoney';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { CustomAttribute, extractAttributeValue } from 'utils/ecommerce/services/extract';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/servicesRowStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IServiceRowProps {
	id: string;
	setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IServiceDataProps {
	packageName: string;
	packageVersion: string;
	amount: string;
	currency: string;
}

const ServiceRow = ({ id, setLoading }: IServiceRowProps) => {
	const [service, setService] = useState<IServiceDataProps | null>(null);
	const classes = useStyles();

	useEffect(() => {
		if (id) {
			setLoading(true);
			ECommerceService.getContentByPartNumber(id).subscribe(({ response }) => {
				if (response.catalogEntryView && response.catalogEntryView.length > 0) {
					const data = response.catalogEntryView[0];
					if (data) {
						const price = (data.price || []).find(
							(singlePrice: { usage: string }) => singlePrice.usage === 'Display'
						);
						const roamingType = extractAttributeValue(data, CustomAttribute.ROAMING_TYPE);
						setService({
							packageName: (roamingType
								? roamingType
								: translate('prepaid.loyalty.add.new.services.other')
							).toLowerCase(),
							packageVersion: data.name,
							amount: price ? price.value : '0',
							currency: price ? price.currency : translate('OMR'),
						});
						setLoading(false);
					}
				}
			});
		}
	}, [id, setLoading]);

	return (
		<div className={classes.servicesRow}>
			<ConditionalRender
				show={!!service}
				onTrue={() => (
					<>
						<span className={classes.nameWrapper}>
							<BodySBold inline>
								<span className="wrapper">{service?.packageName}</span>
							</BodySBold>{' '}
							<BodySBold inline color="disabled-light">
								{service?.packageVersion}
							</BodySBold>
						</span>
						<span className="float-right">
							<BodySBold inline color="disabled-light">
								<>
									{roundMoney(service?.amount || '')} {service?.currency}
								</>
							</BodySBold>
						</span>
					</>
				)}
			/>
		</div>
	);
};

export default ServiceRow;
